module.exports = __webpack_public_path__ + "components/page-header/static/surf-forecast__logo--white-efd8b546d6bda896ae20f0197efb4ee5.png";